import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchTermSource = signal<string>('');

  searchTerm = this.searchTermSource.asReadonly();

  setSearchTerm(term: string) {
    this.searchTermSource.set(term);
  }

  clearSearch() {
    this.searchTermSource.set('');
  }

  /**
   * Normalizes text by converting Unicode characters to ASCII equivalents
   * For example: O₂ -> O2, CO₂ -> CO2
   */
  normalizeSearch(text: string): string {
    if (!text) return '';
    return text
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
      .replace(/[₀₁₂₃₄₅₆₇₈₉]/g, (char) => {
        // Convert subscript numbers to regular numbers
        const subscriptMap: Record<string, string> = {
          '₀': '0',
          '₁': '1',
          '₂': '2',
          '₃': '3',
          '₄': '4',
          '₅': '5',
          '₆': '6',
          '₇': '7',
          '₈': '8',
          '₉': '9',
        };
        return subscriptMap[char] || char;
      })
      .replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹]/g, (char) => {
        // Convert superscript numbers to regular numbers
        const superscriptMap: Record<string, string> = {
          '⁰': '0',
          '¹': '1',
          '²': '2',
          '³': '3',
          '⁴': '4',
          '⁵': '5',
          '⁶': '6',
          '⁷': '7',
          '⁸': '8',
          '⁹': '9',
        };
        return superscriptMap[char] || char;
      });
  }
}
